<template>
    <div>
        <!-- Title of section and filter show/hide button -->
        <panel-header
            :title="this.title"
            :toggle-button-value="filterShow"
            @toggleFilterPanel="toggleFilterPanel"
        ></panel-header>

        <!-- Filter section -->
        <toggle-filter-panel v-if="filterShow"
             :filters="availableFilters"
             :pagination-filter="defaultFilter"
             @filterChange="filterChange"
             @defaultFilterChange="defaultFilterChange"
        ></toggle-filter-panel>

        <br v-if="filterShow" />

        <div class="bg">
            <div class="inner clearfix">
                <data-table
                    :dt-id="route.name + (type ? '-' + type : '')"
                    :my-ajax="dataTableAjax"
                    :columns="columns"
                    :column-defs="columnDefs"
                    :refresh="DTRefresh"
                    on-click-element=".row-details"
                    :on-click-element-event="onClickEvent"
                    :search="{
                        handle: '.dt-df-box',
                        placeholder: t('Name / Index / Ean')
                    }"
                    :search-value="defaultFilter.search"
                    :page-length="defaultFilter.pagination"
                    :sort="false"
                ></data-table>

                <form-export v-if="type === 'group'"
                    :active="this.config && this.config.isDumpActionActive"
                    :action="$http.options.root + '/' + this.$route.name + '/dump'"
                    :filters="filters"
                    :default-filter="defaultFilter"
                ></form-export>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DataTable from "../../components/DataTable.vue";
    import FormExport from "../../components/FormExport";
    import PanelHeader from '../../components/PanelHeader';
    import ToggleFilterPanel from '../../components/ToggleFilterPanel';
    import StationaryShopPanel from '../../components/ProductStationaryAvailability/StationaryShop';

    let DetailsLoader = Vue.extend(StationaryShopPanel);

    export default
    {
        props: {
            route: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                default: null
            },
            title: {
                type: String,
                required: true
            }
        },
        components: {DataTable, PanelHeader, ToggleFilterPanel, FormExport},
        data()
        {
            return {
                filterShow: false,
                config: {},
                columns: [],
                filters: [],
                DTRefresh: false,
                columnDefs: [],
                defaultFilter: {
                    search: '',
                    pagination: 10,
                }
            };
        },
        mounted()
        {
            this.init();
        },
        computed: {
            availableFilters: function() {
                return this.filters.filter((f) => {
                   return !f.type.startsWith('hidden');
                });
            }
        },
        methods:
            {
                init()
                {
                    let type = this.type ? this.type : 'all';
                    let data = {
                        type: type,
                    };

                    this.$http.get(this.route.name + '/init/' + type, {params: data}).then(response => {
                        this.columns = response.body.columns;
                        this.filters = response.body.filters;
                        this.DTRefresh = !this.DTRefresh;
                        this.columnDefs = this.buildColumnDefs();
                    });
                },
                dataTableAjax(data, callback)
                {
                    if (this.type) {
                        data.type = this.type;
                    }
                    delete data.columns;
                    this.$buildFilters(this.filters, data);

                    this.$http.get(this.route.name + '/dt/' + (this.type ? this.type : 'all'), {params: data}).then((response) => {
                        this.searchValue = response.body.searchValue;
                        callback(response.body)
                    })
                },
                buildColumnDefs: function() {
                    let _this = this;
                    let boolColumnIndex = [];
                    let linkColumnIndex = [];
                    let pivotLinkColumnIndex = [];
                    _this.columns.forEach(function(column, index) {
                        if (column.type === 'boolean') {
                            boolColumnIndex.push(index);
                        }
                        if (column.type === 'pivot_link') {
                            pivotLinkColumnIndex.push(index);
                        }
                        if (column.type === 'link') {
                            linkColumnIndex.push(index);
                        }
                    });

                    return [{
                        render: function (data, type, row, settings) {
                            let shopId = null;
                            if (_this.columns[settings.col]) {
                                let index = _this.columns[settings.col].data.split('_');
                                if (index.length > 1 && !isNaN(index[index.length - 1])) {
                                    shopId = index[index.length - 1];
                                }
                            }

                            if (data) {

                                if (row['product_link_' + shopId]) {
                                    data = '<a href="' + row['product_link_' + shopId] + '" target="_blank" rel="noreferrer">' + data + '</a>';
                                }

                                return '<a href="#" class="row-details" data-product-id="' + (row['product_id' + (shopId ? '_' + shopId : '')]) + '" data-shop-id="' + (row['shop_id' + (shopId ? '_' + shopId : '')]) + '">' +
                                    '<span class="glyphicon glyphicon-chevron-down"></span></a><span>' + data + '</span>';
                            }

                            return data;
                        },
                        targets: _this.type ? linkColumnIndex : 0
                    },{
                        render: function (data, type, row, settings) {
                            let shopId = null;
                            if (_this.columns[settings.col]) {
                                let index = _this.columns[settings.col].data.split('_');
                                if (index.length > 1 && !isNaN(index[index.length - 1])) {
                                    shopId = index[index.length - 1];
                                }
                            }
                            if (data) {
                                return '<a href="' + row['product_link' + (shopId ? '_' + shopId : '')] + '">' + data + '</a>';
                            }

                            return data;
                        },
                        targets: linkColumnIndex
                    },{
                        render: function (data, type, row, settings) {
                            return '<a href="' + row['pivot_link'] + '" target="_blank" rel="noreferrer">' + data + '</a>';
                        },
                        targets: pivotLinkColumnIndex
                    },{
                        render: function (data, type, row, settings) {
                            if (data) {
                                return _this.$translate.text('Yes');
                            } else if (false === data) {
                                return _this.$translate.text('No');
                            }

                            return data ? data : '';
                        },
                        targets: boolColumnIndex
                    }];
                },
                onClickEvent: function (id, row, e) {
                    let tr = $(e.target).closest('td');
                    let icon = tr.find('.row-details .glyphicon');
                    let shopId = tr.find('.row-details').attr('data-shop-id');
                    let productId = tr.find('.row-details').attr('data-product-id');
                    if (row.child.isShown()) {
                        row.child.hide();
                        icon.addClass('glyphicon-chevron-down');
                        icon.removeClass('glyphicon-chevron-up')
                    }
                    else {
                        icon.addClass('glyphicon-chevron-up');
                        icon.removeClass('glyphicon-chevron-down');
                        row.child(() => {
                            return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">'+this.$translate.text('Processing')+'...</div></div>';
                        }).show();

                        let propsData = {
                            'shopId': parseInt(shopId),
                            'productId': parseInt(productId),
                            'route': this.route
                        };
                        new DetailsLoader({propsData: propsData}).$mount($(row.child()[0]).find('div')[0])
                    }
                },
                toggleFilterPanel: function(filterShow) {
                    this.filterShow = filterShow;
                },
                filterChange: function(filterName, filterValue, filter) {
                    this.DTRefresh=!this.DTRefresh;
                },
                defaultFilterChange: function(defaultFilter) {
                    this.defaultFilter = defaultFilter;
                },
                checkFilterValue: function() {
                    if (!this.filters) {
                        return false;
                    }

                    return Object.values(this.filters).filter(function(v) {
                       return v.value;
                    }).length > 0;
                }
            }
    }
</script>


<style lang="sass">
</style>


// WEBPACK FOOTER //
// StationaryAvailability.vue?3ad8acee